<div class="flex justify-center items-center h-full">
  <div class="w-full max-w-md">
    <p-card>
      <ng-template pTemplate="header">
        <div class="text-center py-4">
          <h2 class="text-heading-xl mb-2">{{ 'login.title' | translate }}</h2>
          <p class="text-body-sm text-secondary">{{ 'login.subtitle' | translate }}</p>
        </div>
      </ng-template>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6">
        <!-- Email Field -->
        <div class="flex flex-col gap-2">
          <label for="email" class="text-label-md">{{ 'login.email' | translate }}</label>
          <input
            id="email"
            type="email"
            pInputText
            [formControl]="emailControl"
            [placeholder]="'login.emailPlaceholder' | translate"
            class="w-full"
          />
          @if (emailControl.invalid && emailControl.touched) {
            <p-message severity="error">
              {{ getEmailErrorMessage() }}
            </p-message>
          }
        </div>

        <!-- Password Field -->
        <div class="flex flex-col gap-2">
          <label for="password" class="text-label-md">{{ 'login.password' | translate }}</label>
          <p-password
            id="password"
            [formControl]="passwordControl"
            [placeholder]="'login.passwordPlaceholder' | translate"
            [toggleMask]="true"
            [feedback]="false"
            inputStyleClass="w-full"
          ></p-password>
          @if (passwordControl.invalid && passwordControl.touched) {
            <p-message severity="error">
              {{ getPasswordErrorMessage() }}
            </p-message>
          }
        </div>

        <!-- Submit Button -->
        <div class="flex flex-col gap-4">
          <p-button
            type="submit"
            [label]="'login.signIn' | translate"
            class="w-full"
            [disabled]="loginForm.invalid"
            [loading]="false"
          />

          <!-- Additional Options -->
          <div class="text-center">
            <a routerLink="/forgot-password" class="text-caption-lg text-primary hover:underline">{{ 'login.forgotPassword' | translate }}</a>
          </div>
        </div>
      </form>
    </p-card>
  </div>
</div>